const state = {
  leftMenu:[],
  basePath:''
}

const mutations = {
  CHANGE_LEFTMENU:(state, data) => {
    state.leftMenu = data
  },
  CHANGE_BASEPATH:(state, data) => {
    state.basePath = data
  },
}

const actions = {
  changeLeftMenu:({ commit}, data ) => {
    commit('CHANGE_LEFTMENU',data)
  },
  changeBasePath:({ commit}, data ) => {
    commit('CHANGE_BASEPATH',data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/leftMenu.js